// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__q63Wc","content":"Consent_content__22GOj","footer":"Consent_footer__3BVZg"};